<template>
    <div>
        <div v-if="$can('manage.view-booking-actions')" class="d-flex justify-end mb-4">
            <v-btn
                color="#f2c037"
                class="actions-btn"
                @click="actionsDrawer = !actionsDrawer"
            >
                <v-icon class="mr-2" small>mdi-cog-outline</v-icon>
                Ações
            </v-btn>
        </div>

        <right-drawer :show-drawer="actionsDrawer" drawer-width="500px">
            <template v-slot:drawerTitle>
                <div class="ma-0 pa-4 d-flex actions-drawer-title">
                    <v-icon class="mr-4" @click="actionsDrawer = !actionsDrawer" color="#FFF">mdi-arrow-right</v-icon>
                    Ações
                </div>
            </template>
            <template v-slot:drawerBody>
                <div class="pa-4">
                    <v-card v-if="$can('create.resend-pending-bookings')" outlined>
                        <v-card-title class="subtitle-1 font-weight-bold">
                            Reenvio de E-mails
                            <v-tooltip top max-width="320" color="info">
                                <template v-slot:activator="{ on }">
                                    <v-icon color="blue" v-on="on" class="ml-2">mdi-help-circle-outline</v-icon>
                                </template>
                                <span>{{ infoTooltipLabel }}</span>
                            </v-tooltip>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex align-center justify-space-between">
                                <v-tooltip top :disabled="hasPendingBookings" color="grey darken-2">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-on="on" v-bind="attrs" style="display: inline-block;">
                                            <v-btn
                                                color="primary"
                                                :disabled="!hasPendingBookings"
                                                @click="confirmResendDialog = true"
                                                :style="!hasPendingBookings ? 'pointer-events: none;' : ''"
                                            >
                                                <v-icon class="mr-2" small>mdi-email-send-outline</v-icon>
                                                Reenviar Pendentes
                                            </v-btn>
                                        </span>
                                    </template>
                                    <span>{{ resendDisabledTooltip }}</span>
                                </v-tooltip>
                            </div>
                            <div v-if="resendRegistry" class="mt-4 text-caption grey--text">
                                Último disparo: {{ resendRegistry }}
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </template>
            <template v-slot:drawerActions></template>
        </right-drawer>

        <v-dialog v-model="confirmResendDialog" max-width="440px">
            <v-card>
                <v-card-title class="subtitle-1 font-weight-bold">Confirmar reenvio em massa</v-card-title>
                <v-card-text>
                    Deseja reenviar os e-mails de confirmação para todos os hotéis com reservas pendentes nos <strong>últimos 3 dias</strong> (hoje, ontem e anteontem)?
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text @click="confirmResendDialog = false">Cancelar</v-btn>
                    <v-btn color="primary" :loading="resendLoading" @click="resendPendingEmails()">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card class="rounded-lg list-reserves__card">
            <v-card-title class="subtitle-1 font-weight-bold">
                <v-icon left>mdi-filter-variant</v-icon> Filtros de Pesquisa
            </v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            v-model="hotelName"
                            label="Buscar hotel..."
                            dense
                            outlined
                            hide-details
                            v-on:keyup.enter="getData()"
                            class="rounded-lg"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            v-model="protocol"
                            label="Buscar protocolo..."
                            dense
                            outlined
                            hide-details
                            v-on:keyup.enter="getData()"
                            class="rounded-lg"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="pendingInvoice"
                            :items="selectInvoice"
                            item-text="text"
                            item-value="value"
                            label="Situação da Nota Fiscal"
                            dense
                            outlined
                            hide-details
                            class="rounded-lg"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="status"
                            :items="selectStatus"
                            item-text="text"
                            item-value="value"
                            label="Situação da Reserva"
                            dense
                            outlined
                            hide-details
                            class="rounded-lg"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <assign-user-autocomplete
                            :value="currentAssigneeFilter"
                            :no-assignee-option="true"
                            label="Atuante"
                            placeholder="Filtrar por atuante"
                            class="rounded-lg"
                            @input="onAssigneeFilterChange"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="erpStatus"
                            :items="selectErpStatus"
                            item-text="text"
                            item-value="value"
                            label="Integrado ERP"
                            dense
                            outlined
                            hide-details
                            class="rounded-lg"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-select
                            v-model="urgency"
                            :items="selectUrgency"
                            item-text="text"
                            item-value="value"
                            label="Prioridade"
                            dense
                            outlined
                            hide-details
                            multiple
                            class="rounded-lg"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            v-model="orderid"
                            label="Protocolo Onfly..."
                            dense
                            outlined
                            hide-details
                            v-on:keyup.enter="getData()"
                            class="rounded-lg"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            v-model="menuCheckIn"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="checkInText"
                                    label="Check-in"
                                    dense
                                    outlined
                                    hide-details
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    class="rounded-lg"
                                    @click:clear="clearCheckIn"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="checkInDates"
                                range
                                no-title
                                locale="pt-br"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="3">
                        <v-menu
                            v-model="menuCheckOut"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="checkOutText"
                                    label="Check-out"
                                    dense
                                    outlined
                                    hide-details
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    clearable
                                    class="rounded-lg"
                                    @click:clear="clearCheckOut"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="checkOutDates"
                                range
                                no-title
                                locale="pt-br"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="ml-2 mb-2">
                <v-btn
                    depressed
                    color="#FBC02D"
                    v-on:click="getCleanFilter()"
                    class="white--text rounded-lg"
                >
                    <v-icon left>mdi-eraser</v-icon>
                    Limpar
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    v-on:click="searchData()"
                    class="rounded-lg"
                >
                    <v-icon left>mdi-magnify</v-icon>
                    Buscar
                </v-btn>
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }" >
                        <v-btn
                            depressed
                            outlined
                            class="ml-2 rounded-lg"
                            v-on="on"
                            color="primary"
                            :loading="awaitingExportProcessing"
                            @click="exportTable()"
                            :disabled="isItemsEmpty"
                        >
                            <v-icon color="primary">mdi-download</v-icon>
                        </v-btn>
                    </template>
                    Exportar Dados em XLS
                </v-tooltip>
            </v-card-actions>

            <v-data-table
                :footer-props="{itemsPerPageOptions:[1,5,10,25,50,100]}"
                :expanded.sync="itemsPerPage"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="dataTable pt-2 pb-1"
            >
                <template v-slot:item.urgency="{ item }">
                    <v-tooltip max-width="220" color="black" bottom class="urgency-chip__tooltip">
                        <template v-slot:activator="{ on }">
                            <span v-on="on" class="urgency-container d-flex align-center">
                                <span :class="getUrgency(item).dotClass"></span>
                                <span :style="{ color: getUrgency(item).labelColor }" class="urgency-label">
                                    {{ getUrgency(item).label }}
                                </span>
                            </span>
                        </template>
                        <span class="urgency-chip__tooltip-info">
                            <v-icon color="white" x-small class="mr-1">
                                mdi-timer-outline
                            </v-icon>
                            {{ getUrgency(item).tooltipInfo }}
                        </span>
                    </v-tooltip>
                </template>

                <template v-slot:item.hotel.name="{ item }">
                    <span class="semi-bold">{{ item.hotel.name }}</span>
                </template>

                <template v-slot:item.order_id_system="{ item }">
                    <span class="semi-bold">{{ item.order_id_system }}</span>
                </template>

                <template v-slot:item.status="{ item }">
                    <v-chip
                        class="ma-2 status-chip"
                        :class="`status-chip--${item.status}`"
                        small
                    >
                        {{ getStatus(item) }}
                    </v-chip>
                </template>

                <template v-slot:item.check_in="{ item }">
                    {{ parseDate(item.check_in, 'DD/MM/YYYY ') }}
                </template>

                <template v-slot:item.check_out="{ item }">
                    {{ parseDate(item.check_out, 'DD/MM/YYYY ') }}
                </template>

                <template v-slot:item.created_at="{ item }">
                    <div class="created-container">
                        <span class="created-date semi-bold">{{ parseDate(item.created_at, 'DD/MM/YYYY') }}</span>
                        <span class="created-hour">{{ parseDate(item.created_at, 'HH:mm:ss') }}</span>
                    </div>
                </template>

                <template v-slot:item.invoice="{ item }">
                    {{ getInvoice( item) }}
                </template>

                <template v-slot:item.integrated_with_erp="{ item }">
                    <span
                        class="erp-text"
                        :class="item.integrated_with_erp ? 'erp-text--yes' : 'erp-text--no'"
                    >
                        {{ getIntegratedWithErpStatus(item) }}
                    </span>
                </template>

                <template v-slot:item.current_assignee="{ item }">
                    {{ item.current_assignee ? item.current_assignee.name : '—' }}
                </template>

                <template v-slot:item.actions="{ item }">
                    <span class="actions-container">
                        <router-link :to="{name: 'detailReserve', params: {id: item.id}}">
                        <v-btn class="action-icon-btn rounded-lg" small elevation="0">
                            <v-icon small>mdi-eye-plus</v-icon>
                        </v-btn>
                        </router-link>
                        <v-btn
                            class="action-icon-btn rounded-lg"
                            small
                            elevation="0"
                            v-if="hasInvoice(item.id)"
                            @click="downloadInvoice(item.id)"
                        >
                            <v-icon small>mdi-cloud-download</v-icon>
                        </v-btn>
                        <v-btn v-else class="action-icon-btn rounded-lg " small elevation="0">
                            <v-icon small>mdi-cloud-download-outline</v-icon>
                        </v-btn>
                    </span>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import {downloadFile, getFileNameWithSalt} from "../services/DownloadFileService";
import {HttpResponseHelper} from "../helpers/HttpResponseHelper";
import RightDrawer from "../components/Modals/RightDrawer.vue";
import AssignUserAutocomplete from "../components/Reserve/AssignUserAutocomplete.vue";

export default {
    name: "ListReserve",

    components: {
        RightDrawer,
        AssignUserAutocomplete,
    },

    data: () => ({
        filtersOpen: false,
        urgency: [],
        itemsPerPage: [4, 8, 12],
        dialog: false,
        hotelName: '',
        protocol: '',
        orderid:'',
        pendingInvoice: '',
        creatorName: '',
        thisMonth: '',
        status: '',
        erpStatus: '',
        currentAssigneeFilter: null,
        loading: true,
        total: 0,
        options: {
            sortDesc: [true],
        },
        menuCheckIn: false,
        checkInDates: [],
        checkInText: '',
        menuCheckOut: false,
        checkOutDates: [],
        checkOutText: '',
        selectStatus: [
            {text: 'pendente', value: 'pending' },
            {text: 'pagamento pendente', value: 'pendingPayment'},
            {text: 'confirmado', value:'confirmed'},
            {text: 'cancelado', value:'canceled'},
            {text: 'nao respondido', value:'unanswered'},
            {text: 'pagamento nao efetuado', value:'unpaid'},
        ],
        selectInvoice: [
            {text: 'Pendente', value: 'pending' },
            {text: 'Anexada', value:'attached'},
        ],
        selectErpStatus: [
            {text: 'sim', value: 'integrated'},
            {text: 'não', value: 'notIntegrated'}
        ],
        selectUrgency: [
            {text: 'Muito alta', value: 'very-high'},
            {text: 'Alta', value: 'high'},
            {text: 'Padrão', value: 'default'}
        ],
        headers: [
            {text: 'Prioridade', value: 'urgency', sortable: false},
            {text: 'Hotel', value: 'hotel.name', sortable: false},
            {text: 'Protocolo', value: 'id', sortable: false},
            {text: 'Protocolo Onfly', value:'order_id_system',sortable: false},
            {text: 'Situação da Reserva', value: 'status'},
            {text: 'Check-In', value: 'check_in' , sortable: false},
            {text: 'Check-Out', value: 'check_out' , sortable: false},
            {text: 'Criada em', value: 'created_at' , sortable: false},
            {text: 'Nota Fiscal', value: 'invoice'},
            {text: 'Integrado ERP', value: 'integrated_with_erp', sortable: false},
            {text: 'Atuante', value: 'current_assignee', sortable: false},
            {text: 'Ação', value: 'actions', sortable: false},
        ],
        items: [],
        awaitingExportProcessing: false,
        actionsDrawer: false,
        confirmResendDialog: false,
        resendLoading: false,
        resendRegistry: null,
        hasPendingBookings: false,
        recentlySubmitted: false,
        infoTooltipLabel: 'Reenvia o email para reservas pendentes dos últimos 3 dias (hoje, ontem e anteontem).',
    }),

    computed: {
        isItemsEmpty() {
            return !this.items || this.items.length === 0;
        },
        resendDisabledTooltip() {
            return this.recentlySubmitted
                ? 'Os e-mails já foram reenviados recentemente.'
                : 'Nenhuma reserva pendente para disparar nos últimos 3 dias.';
        },
    },

    mounted () {
        this.initFiltersBasedOnQueryParams();
        this.getResendRegistry();
    },
    methods: {
        initFiltersBasedOnQueryParams () {
            if(Object.keys(this.$route.query).length) {
                const {
                    sort, sortDesc, page, perPage,
                    hotelName, protocol, orderid, creatorName,
                    pendingInvoice, status, thisMonth,
                    check_in_start, check_in_end, check_out_start, check_out_end,
                    current_assignee_id, current_assignee_name
                } = this.$route.query;

                if(sort) this.options.sortBy = sort;
                if(pendingInvoice) this.pendingInvoice = pendingInvoice;
                if(sortDesc) this.options.sortDesc = sortDesc;
                if(page) this.options.page = parseInt(page ? page : 1);
                if(perPage) this.options.perPage = perPage;
                if(hotelName) this.hotelName = hotelName;
                if(protocol) this.protocol = protocol;
                if(orderid) this.orderid = orderid;
                if(creatorName) this.creatorName = creatorName;
                if(status) this.status = status;
                if(thisMonth) this.thisMonth = thisMonth;
                if (current_assignee_id) {
                    const parsedAssigneeId = parseInt(current_assignee_id, 10);
                    this.currentAssigneeFilter = {
                        id: current_assignee_id === 'null' ? 'null' : (isNaN(parsedAssigneeId) ? null : parsedAssigneeId),
                        name: current_assignee_name || current_assignee_id,
                    };
                }
                if (check_in_start) {
                    this.checkInDates = [check_in_start];
                    if (check_in_end) this.checkInDates.push(check_in_end);
                }
                if (check_out_start) {
                    this.checkOutDates = [check_out_start];
                    if (check_out_end) this.checkOutDates.push(check_out_end);
                }
            }
        },
        parseDate(date, format) {
            return moment(date).format(format);
        },
        formatDateInput(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        clearCheckIn() {
            this.checkInDates = [];
            this.checkInText = '';
            this.getData();
        },
        clearCheckOut() {
            this.checkOutDates = [];
            this.checkOutText = '';
            this.getData();
        },
        onAssigneeFilterChange(value) {
            this.currentAssigneeFilter = value;
        },
        searchData() {
            if (this.options.page !== 1) {
                this.options.page = 1;
                return;
            }

            this.getData();
        },
        getStatus( item){
            if(item.status === "canceled"){
                return "Cancelado"
            }
            if(item.status === "confirmed"){
                return "Confirmado"
            }
            if(item.status === "pendingPayment"){
                return "Pagamento pendente"
            }
            if(item.status === "pending"){
                return "Pendente"
            }
            if(item.status === "unanswered"){
                return "Não respondido"
            }
            if(item.status === "unpaid"){
                return "Pagamento não efetuado"
            }
        },
        getCleanFilter(){
            this.$router.replace({'query': null});
            window.location.reload();
        },
        getInvoice(item){
            if(item.invoice == null){
                return "Pendente"
            }
            return "Anexada"
        },
        getIntegratedWithErpStatus(item){
            return item.integrated_with_erp ? "Sim" : "Não";
        },
        getData() {
            this.loading = true;
            const queryParams = this.getQueryParams();
            this.$router.push({ query: queryParams });

            axios.get('api/booking', { params: queryParams })
                .then(res => {
                    this.items = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                });
        },
        downloadInvoice(id){
            window.open(`/api/invoice/download/${id}` ,"_blank")
        },
        hasInvoice(id) {
            return this.items.find((i) => i.id == id).invoice !== null;
        },
        getQueryParams () {
            const {sortBy, sortDesc, page, itemsPerPage} = this.options;
            return {
                sort: sortBy,
                sortDesc: sortDesc,
                page: page,
                perPage: itemsPerPage,
                hotelName: this.hotelName,
                protocol: this.protocol,
                orderid: this.orderid,
                creatorName: this.creatorName,
                pendingInvoice: this.pendingInvoice,
                status: this.status,
                erpStatus: this.erpStatus,
                thisMonth: this.thisMonth,
                current_assignee_id: this.currentAssigneeFilter ? this.currentAssigneeFilter.id : null,
                current_assignee_name: this.currentAssigneeFilter ? this.currentAssigneeFilter.name : null,
                check_in_start: this.getFormattedDate(this.checkInDates[0], 'YYYY-MM-DD'),
                check_in_end: this.getFormattedDate(this.checkInDates[1], 'YYYY-MM-DD'),
                check_out_start: this.getFormattedDate(this.checkOutDates[0], 'YYYY-MM-DD'),
                check_out_end: this.getFormattedDate(this.checkOutDates[1], 'YYYY-MM-DD'),
                priority: this.urgency.length ? this.urgency : undefined
            };
        },
        getFormattedDate (dateFieldValue, format) {
            return dateFieldValue ? moment(dateFieldValue).format(format) : '';
        },
        getResendRegistry() {
            axios.get('/api/booking/resend-pending-registry')
                .then(res => {
                    this.resendRegistry = res.data.resendRegistry;
                    this.hasPendingBookings = res.data.hasPendingBookings;
                });
        },

        async resendPendingEmails() {
            this.resendLoading = true;
            try {
                const res = await axios.post('/api/retry/resend-pending');
                this.resendRegistry = res.data.resendRegistry;
                this.hasPendingBookings = false;
                this.recentlySubmitted = true;
                this.confirmResendDialog = false;
                this.$simpleDialog(`E-mails reenviados com sucesso!`, 'success');
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao reenviar os e-mails.', 'error');
            } finally {
                this.resendLoading = false;
            }
        },

        getUrgency(item) {
            const hoursUntilCheckin = moment(item.check_in).diff(moment(), 'hours');
            const isPending = item.status === 'pending' || item.status === 'pendingPayment';

            if (isPending && hoursUntilCheckin < 24) {
                return {
                    label: 'Muito alta',
                    dotClass: 'urgency-dot urgency-dot--very-high urgency-very-high',
                    labelColor: '#b71c1c',
                    tooltipInfo: 'Essa reserva está pendente e faltam menos de 24 horas até a data do check-in'
                };
            }

            if (isPending && hoursUntilCheckin < 48) {
                return {
                    label: 'Alta',
                    dotClass: 'urgency-dot urgency-dot--high urgency-high',
                    labelColor: '#f57f17',
                    tooltipInfo: 'Essa reserva está pendente e faltam menos de 48 horas até a data do check-in'
                };
            }

            if (isPending) {
                return {
                    label: 'Padrão',
                    dotClass: 'urgency-dot urgency-dot--default',
                    labelColor: '#2e7d32',
                    tooltipInfo: 'Essa reserva está pendente e faltam mais de 48 horas até a data do check-in'
                };
            }

            return {
                label: 'Sem prioridade',
                dotClass: 'urgency-dot urgency-dot--no-priority',
                labelColor: '#616161',
                tooltipInfo: 'Essa reserva não está mais pendente, e por isso não tem prioridade'
            };
        },

        async exportTable () {
            try {
                this.awaitingExportProcessing = true;
                const response = await axios.get('/api/booking/export', {params: this.getQueryParams(), responseType: 'blob'});
                HttpResponseHelper.isJsonResponse(response)
                    ? this.handleExportMessage(await HttpResponseHelper.blobResponseToJson(response))
                    : this.handleExportDownload(response.data);
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao baixar os dados.', 'error');
            } finally {
                this.awaitingExportProcessing = false;
            }
        },
        handleExportDownload (response) {
            downloadFile(response, getFileNameWithSalt('reservas_partner_hub'), 'xls');
        },
        handleExportMessage (response) {
            this.$simpleDialog(response.message, response.success ? 'success' :'error');
        },
    },
    watch: {
        options: {
            handler() {
                this.getData()
            },
            deep: true,
        },
        checkInDates() {
            if (this.checkInDates.length > 0) {
                let start = this.formatDateInput(this.checkInDates[0]);
                this.checkInText = start;

                if (this.checkInDates[1]) {
                    let end = this.formatDateInput(this.checkInDates[1]);
                    if (this.checkInDates[0] > this.checkInDates[1]) {
                        this.checkInText = end + " até " + start;
                        this.checkInDates.sort();
                    } else {
                        this.checkInText = start + " até " + end;
                    }
                }
            } else {
                this.checkInText = '';
            }
        },
        checkOutDates() {
            if (this.checkOutDates.length > 0) {
                let start = this.formatDateInput(this.checkOutDates[0]);
                this.checkOutText = start;

                if (this.checkOutDates[1]) {
                    let end = this.formatDateInput(this.checkOutDates[1]);
                    if (this.checkOutDates[0] > this.checkOutDates[1]) {
                        this.checkOutText = end + " até " + start;
                        this.checkOutDates.sort();
                    } else {
                        this.checkOutText = start + " até " + end;
                    }
                }
            } else {
                this.checkOutText = '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.actions-btn {
    color: #FFF;
}

.action-icon-btn {
    background-color: transparent;
    border: 1px solid #CFD0D2 !important;
    min-width: unset !important;
    width: 32px;
    padding: 0.25rem !important;
}

.actions-drawer-title {
    background-color: #1976d2;
    color: #FFF;
    width: 100%;
    height: 100%;
}

.list-reserves__card {
    padding: 0 0.75rem 0.75rem 0.54rem !important;
}

.dataTable {
    padding: 0.5rem;
    border: 1px solid rgba(0, 0, 0, .12);
    border-radius: 0.75rem;
    margin-top: 1.5rem;

    :deep(table tbody tr td) {
        font-size: 0.875rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    :deep(span.semi-bold) {
        font-weight: 500 !important;
    }

    :deep(.created-container) {
        display: flex;
        flex-direction: column;

        .created-hour {
            font-size: 0.75rem;
            font-weight: 400;
        }
    }

    :deep(.actions-container) {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }
}

.detailReserve:hover {
    color: #fbc02d;
}
.downloadInvoice:hover {
    color: #009efb;
}
a {
    text-decoration: none;
}

@keyframes urgency-ring-high {
    0%   { box-shadow: 0 0 0 0px rgba(251, 192, 45, 0.7); }
    70%  { box-shadow: 0 0 0 7px rgba(251, 192, 45, 0); }
    100% { box-shadow: 0 0 0 0px rgba(251, 192, 45, 0); }
}

@keyframes urgency-ring-very-high {
    0%   { box-shadow: 0 0 0 0px rgba(244, 67, 54, 0.7); }
    70%  { box-shadow: 0 0 0 7px rgba(244, 67, 54, 0); }
    100% { box-shadow: 0 0 0 0px rgba(244, 67, 54, 0); }
}

.urgency-high      { animation: urgency-ring-high 1.75s ease-out infinite; }
.urgency-very-high { animation: urgency-ring-very-high 1.25s ease-out infinite; }

.urgency-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
}
.urgency-dot--very-high     { background-color: #f44336; }
.urgency-dot--high          { background-color: #fbc02d; }
.urgency-dot--default        { background-color: #43a047; }
.urgency-dot--no-priority { background-color: #9e9e9e; }

.urgency-container {
    min-width: 92px;
}

.urgency-label {
    font-weight: 500;
}

.urgency-chip__tooltip {
    margin-top: 1rem;

    &-info {
        font-size: 0.75rem;
    }
}

.status-chip {
    font-weight: 600;
}

.status-chip--confirmed      { background-color: rgba(76, 175, 80, 0.15)   !important; color: #2e7d32 !important; }
.status-chip--canceled       { background-color: rgba(244, 67, 54, 0.15)   !important; color: #b71c1c !important; }
.status-chip--pending        { background-color: rgba(251, 192, 45, 0.15)  !important; color: #f57f17 !important; }
.status-chip--pendingPayment { background-color: rgba(255, 152, 0, 0.15)   !important; color: #e65100 !important; }
.status-chip--unanswered     { background-color: rgba(158, 158, 158, 0.15) !important; color: #424242 !important; }
.status-chip--unpaid         { background-color: rgba(255, 87, 34, 0.15)   !important; color: #bf360c !important; }

.erp-text { font-weight: 600; }
.erp-text--yes { color: #2e7d32 !important; }
.erp-text--no  { color: #b71c1c !important; }

</style>
